import { Tree } from '@/utils/Tree';

type objT = number | string | boolean | null | objT[] | { [key: string]: objT };

export const parseObject = (
  labelTree: Tree,
  obj: objT,
  depth: number,
  isParentArray: boolean,
): void => {
  /**
   * JSON에서 가져온 것이기에, 가능한 value의 type는 string, number, object, array, boolean, null 중 하나
   * string, number, boolean, null 또는 array 또는 object로 나눠서 생각
   */
  if (['string', 'number', 'boolean'].includes(typeof obj) || obj === null) {
    // string, number, boolean, null일 때는 추가로 들어갈 depth가 없으니 마무리
    labelTree.add({
      name: '',
      type: typeof obj,
      example: obj === null ? '' : obj.toString(),
      depth: depth,
      isItem: isParentArray,
    });
  } else if (Array.isArray(obj)) {
    // array일 때는 type를 array로 추가한 후, 내부 첫 번째 element에 대해 parseObject 실행
    labelTree.add({
      name: '',
      type: 'array',
      example: '',
      depth: depth,
      isItem: isParentArray,
    });
    parseObject(labelTree, obj[0], depth + 1, true);
  } else if (typeof obj === 'object') {
    if (isParentArray) {
      // object의 parent가 array 형식일 때는 depth를 한 번 더 들어가야 한다
      labelTree.add({
        name: '',
        type: 'object',
        example: '',
        depth: depth,
        isItem: isParentArray,
      });
      parseObject(labelTree, obj, depth + 1, false);
    } else {
      //nested된 object들은 key를 가지고 있기 때문에, 동일한 과정을 한 번 더 진행
      Object.keys(obj).forEach((key: string) => {
        if (
          ['string', 'number', 'boolean'].includes(typeof obj[key]) ||
          obj[key] === null
        ) {
          labelTree.add({
            name: key,
            type: typeof obj[key],
            example:
              obj[key] === null
                ? ''
                : (obj[key] as string | number | boolean).toString(),
            depth: depth,
            isItem: isParentArray,
          });
        } else if (Array.isArray(obj[key])) {
          labelTree.add({
            name: key,
            type: 'array',
            example: '',
            depth: depth,
            isItem: isParentArray,
          });

          parseObject(labelTree, (obj[key] as objT[])[0], depth + 1, true);
        } else {
          labelTree.add({
            name: key,
            type: 'object',
            example: '',
            depth: depth,
            isItem: isParentArray,
          });

          parseObject(labelTree, obj[key], depth + 1, false);
        }
      });
    }
  }
};
